<div class="community-page">

  <!-- Tab 切換 -->
  <ul class="nav nav-tabs community-tabs">
    <li class="nav-item" (click)="choose('0')">
      <a onclick="return false;" [class.active]="now=='0'" class="nav-link" href="#">
        <i class="fas fa-users mr-1"></i>社群帳號管理
      </a>
    </li>
    <li class="nav-item" (click)="choose('1')">
      <a onclick="return false;" [class.active]="now=='1'" class="nav-link" href="#">
        <i class="fas fa-chart-bar mr-1"></i>每日統計
      </a>
    </li>
    <li class="nav-item" (click)="choose('2')">
      <a onclick="return false;" [class.active]="now=='2'" class="nav-link" href="#">
        <i class="fas fa-chart-pie mr-1"></i>圖表分析
      </a>
    </li>
    <li class="nav-item" (click)="choose('3')">
      <a onclick="return false;" [class.active]="now=='3'" class="nav-link" href="#">
        <i class="fas fa-tachometer-alt mr-1"></i>經紀指標
      </a>
    </li>
  </ul>

  <!-- ══ Tab 0: 社群帳號管理 ══════════════════════════════════ -->
  <div *ngIf="now=='0'" class="tab-panel">

    <!-- 篩選區 -->
    <div class="filter-card">
      <div class="form-row align-items-end">
        <div class="form-group col-auto mb-1">
          <label>類型</label>
          <select class="form-control form-control-sm" [(ngModel)]="acct_filter_type" (change)="acct_do_filter()">
            <option value="">全部</option>
            <option *ngFor="let t of type_options" [value]="t.id">{{ t.name }}</option>
          </select>
        </div>
        <div class="form-group col-auto mb-1">
          <label>經紀</label>
          <select class="form-control form-control-sm" [(ngModel)]="acct_filter_agent" (change)="acct_do_filter()">
            <option value="">全部</option>
            <option *ngFor="let v of vendor_list" [value]="v.name">{{ v.name }}</option>
          </select>
        </div>
        <div class="form-group col-auto mb-1">
          <label>狀態</label>
          <select class="form-control form-control-sm" [(ngModel)]="acct_filter_status" (change)="acct_do_filter()">
            <option value="">全部</option>
            <option value="1">上架</option>
            <option value="0">下架</option>
          </select>
        </div>
        <div class="form-group col-auto mb-1">
          <label>帳號 / URL</label>
          <input type="text" class="form-control form-control-sm" [(ngModel)]="acct_filter_keyword"
            placeholder="關鍵字" (ngModelChange)="detect_filter_type_from_keyword()" (keyup.enter)="acct_do_filter()">
        </div>
        <div class="form-group col-auto mb-1">
          <button class="btn btn-primary btn-sm mr-1" (click)="acct_do_filter()">
            <i class="fas fa-search mr-1"></i>篩選
          </button>
          <button class="btn btn-outline-secondary btn-sm" (click)="acct_reset_filter()">
            <i class="fas fa-redo mr-1"></i>重置
          </button>
        </div>
      </div>
    </div>

    <!-- 工具列 -->
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div>
        <button class="btn btn-primary" (click)="open_add_modal()">
          <i class="fas fa-plus mr-1"></i>新增社群帳號
        </button>
      </div>
      <span class="result-count">篩選結果：{{ account_filtered.length }} 筆</span>
    </div>

    <!-- 帳號表格 -->
    <div class="table-wrapper">
      <table class="table table-hover mb-0">
        <thead>
          <tr>
            <th>帳號名稱</th>
            <th>URL</th>
            <th>類型</th>
            <th>經紀</th>
            <th>外部 ID</th>
            <th>狀態</th>
            <th style="min-width:180px;">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of account_paged">
            <td class="font-weight-bold">{{ item.account_name }}</td>
            <td>
              <a [href]="item.url" target="_blank" class="url-link">{{ item.url }}</a>
            </td>
            <td>
              <span class="type-badge" [ngClass]="'type-' + item.type">{{ get_type_label(item.type) }}</span>
            </td>
            <td>{{ item.agent_name }}</td>
            <td>
              <span *ngIf="item.community_id" class="badge badge-success">{{ item.community_id }}</span>
              <span *ngIf="!item.community_id" class="text-muted small">未登錄</span>
            </td>
            <td>
              <span class="status-dot" [class.active]="item.is_enable=='1'"></span>
              {{ item.is_enable=='1' ? '上架' : '下架' }}
            </td>
            <td>
              <div class="btn-group btn-group-sm">
                <button class="btn btn-outline-primary"
                  (click)="open_edit_modal(item)"><i class="fas fa-edit"></i></button>
                <button class="btn" [ngClass]="item.is_enable=='1'?'btn-outline-danger':'btn-outline-success'"
                  (click)="toggle_enable(item)" [title]="item.is_enable=='1' ? '下架' : '上架'">
                  <i class="fas" [ngClass]="item.is_enable=='1'?'fa-toggle-on':'fa-toggle-off'"></i>
                </button>
                <button class="btn btn-outline-info" [disabled]="!item.community_id || is_crawling(item)"
                  (click)="trigger_crawl(item)" title="觸發爬文">
                  <i class="fas" [ngClass]="is_crawling(item)?'fa-spinner fa-spin':'fa-spider'"></i>
                </button>
              </div>
            </td>
          </tr>
          <tr *ngIf="account_filtered.length==0 && !loading">
            <td colspan="9" class="text-center text-muted py-4">無符合資料</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 帳號分頁 -->
    <div class="pager-bar" *ngIf="account_total_pages > 1">
      <ul class="pagination pagination-sm mb-0">
        <li class="page-item" [class.disabled]="account_page === 1">
          <a class="page-link" href="javascript:void(0)" (click)="account_go_page(account_page - 1)">
            <i class="fas fa-chevron-left"></i>
          </a>
        </li>
        <li class="page-item" *ngFor="let p of account_page_list" [class.active]="p === account_page">
          <a class="page-link" href="javascript:void(0)" (click)="account_go_page(p)">{{ p }}</a>
        </li>
        <li class="page-item" [class.disabled]="account_page === account_total_pages">
          <a class="page-link" href="javascript:void(0)" (click)="account_go_page(account_page + 1)">
            <i class="fas fa-chevron-right"></i>
          </a>
        </li>
      </ul>
      <span class="pager-info">第 {{ account_page }} / {{ account_total_pages }} 頁</span>
    </div>
  </div>

  <!-- ══ Tab 1: 每日統計 ═══════════════════════════════════════ -->
  <div *ngIf="now=='1'" class="tab-panel">

    <!-- 篩選區 -->
    <div class="filter-card">
      <div class="form-row align-items-end">
        <div class="form-group col-auto mb-1">
          <label>開始日期</label>
          <input type="date" class="form-control form-control-sm" [(ngModel)]="filter_date_start">
        </div>
        <div class="form-group col-auto mb-1">
          <label>結束日期</label>
          <input type="date" class="form-control form-control-sm" [(ngModel)]="filter_date_end">
        </div>
        <div class="form-group col-auto mb-1">
          <label>類型</label>
          <select class="form-control form-control-sm" [(ngModel)]="filter_type">
            <option value="">全部</option>
            <option *ngFor="let t of type_options" [value]="t.id">{{ t.name }}</option>
          </select>
        </div>
        <div class="form-group col-auto mb-1">
          <label>經紀</label>
          <select class="form-control form-control-sm" [(ngModel)]="filter_agent">
            <option value="">全部</option>
            <option *ngFor="let v of vendor_list" [value]="v.name">{{ v.name }}</option>
          </select>
        </div>
        <div class="form-group col-auto mb-1">
          <label>搜尋帳號</label>
          <input type="text" class="form-control form-control-sm" [(ngModel)]="filter_keyword" placeholder="帳號名稱關鍵字">
        </div>
        <div class="form-group col-auto mb-1">
          <button class="btn btn-primary btn-sm mr-1" (click)="do_filter()"><i class="fas fa-search mr-1"></i>搜尋</button>
          <button class="btn btn-outline-secondary btn-sm" (click)="reset_filter()"><i class="fas fa-redo mr-1"></i>重置</button>
        </div>
      </div>
    </div>

    <!-- 統計表格 -->
    <div class="table-wrapper">
      <table class="table table-hover table-sm mb-0">
        <thead>
          <tr>
            <th class="sortable" (click)="toggle_sort('target_date')">
              統計日期 <i class="fas" [ngClass]="get_sort_icon('target_date')"></i>
            </th>
            <th>帳號</th>
            <th>類型</th>
            <th>經紀</th>
            <th class="text-center sortable" (click)="toggle_sort('post_count')">
              發文數 <i class="fas" [ngClass]="get_sort_icon('post_count')"></i>
            </th>
            <th class="text-center sortable" (click)="toggle_sort('like_count')">
              點讚數 <i class="fas" [ngClass]="get_sort_icon('like_count')"></i>
            </th>
            <th class="text-center sortable" (click)="toggle_sort('view_count')">
              觀看次數 <i class="fas" [ngClass]="get_sort_icon('view_count')"></i>
            </th>
            <th class="text-center sortable" (click)="toggle_sort('comment_count')">
              留言數 <i class="fas" [ngClass]="get_sort_icon('comment_count')"></i>
            </th>
            <th class="text-center sortable" (click)="toggle_sort('share_count')">
              分享次數 <i class="fas" [ngClass]="get_sort_icon('share_count')"></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let stat of stats_list">
            <td>{{ stat.target_date }}</td>
            <td class="font-weight-bold">{{ stat.account_name }}</td>
            <td>
              <span class="type-badge" [ngClass]="'type-' + stat.type">{{ get_type_label(stat.type) }}</span>
            </td>
            <td>{{ stat.agent_name }}</td>
            <td class="text-center">
              <a href="javascript:void(0)" class="stat-num" (click)="open_detail(stat,'post_count')" data-toggle="modal" data-target="#detailModal">
                {{ stat.post_count | number }}
              </a>
            </td>
            <td class="text-center">
              <a href="javascript:void(0)" class="stat-num" (click)="open_detail(stat,'like_count')" data-toggle="modal" data-target="#detailModal">
                {{ stat.like_count | number }}
              </a>
            </td>
            <td class="text-center">
              <a href="javascript:void(0)" class="stat-num" (click)="open_detail(stat,'view_count')" data-toggle="modal" data-target="#detailModal">
                {{ stat.view_count | number }}
              </a>
            </td>
            <td class="text-center">
              <a href="javascript:void(0)" class="stat-num" (click)="open_detail(stat,'comment_count')" data-toggle="modal" data-target="#detailModal">
                {{ stat.comment_count | number }}
              </a>
            </td>
            <td class="text-center">
              <a href="javascript:void(0)" class="stat-num" (click)="open_detail(stat,'share_count')" data-toggle="modal" data-target="#detailModal">
                {{ stat.share_count | number }}
              </a>
            </td>
          </tr>
          <tr *ngIf="stats_list.length==0 && !loading">
            <td colspan="9" class="text-center text-muted py-4">無資料</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 統計分頁 -->
    <div class="pager-bar" *ngIf="stats_total > 0">
      <ul class="pagination pagination-sm mb-0" *ngIf="stats_total_pages > 1">
        <li class="page-item" [class.disabled]="stats_page === 1">
          <a class="page-link" href="javascript:void(0)" (click)="stats_go_page(stats_page - 1)"><i class="fas fa-chevron-left"></i></a>
        </li>
        <li class="page-item" *ngFor="let p of stats_page_list" [class.active]="p === stats_page">
          <a class="page-link" href="javascript:void(0)" (click)="stats_go_page(p)">{{ p }}</a>
        </li>
        <li class="page-item" [class.disabled]="stats_page === stats_total_pages">
          <a class="page-link" href="javascript:void(0)" (click)="stats_go_page(stats_page + 1)"><i class="fas fa-chevron-right"></i></a>
        </li>
      </ul>
      <span class="pager-info">共 {{ stats_total }} 筆，第 {{ stats_page }} / {{ stats_total_pages }} 頁</span>
    </div>
  </div>

  <!-- ══ Tab 2: 圖表分析 ═══════════════════════════════════════ -->
  <div *ngIf="now=='2'" class="tab-panel">

    <!-- 篩選區 -->
    <div class="filter-card">
      <div class="form-row align-items-end">
        <div class="form-group col-auto mb-1">
          <label>開始日期</label>
          <input type="date" class="form-control form-control-sm" [(ngModel)]="chart_filter_date_start">
        </div>
        <div class="form-group col-auto mb-1">
          <label>結束日期</label>
          <input type="date" class="form-control form-control-sm" [(ngModel)]="chart_filter_date_end">
        </div>
        <div class="form-group col-auto mb-1">
          <button class="btn btn-primary btn-sm mr-1" (click)="chart_do_filter()">
            <i class="fas fa-search mr-1"></i>篩選
          </button>
          <button class="btn btn-outline-secondary btn-sm" (click)="chart_reset_filter()">
            <i class="fas fa-redo mr-1"></i>重置
          </button>
        </div>
      </div>
    </div>

    <!-- 圖表區域 -->
    <div *ngIf="chart_ready">
      <div class="chart-grid">

        <!-- 1. 各經紀占總貢獻百分比 -->
        <div class="chart-card">
          <highcharts-chart
            [Highcharts]="Highcharts"
            [options]="agentPieOptions"
            style="width:100%; display:block;">
          </highcharts-chart>
        </div>

        <!-- 2. 經紀單一社群占各社群百分比 -->
        <div class="chart-card">
          <div class="chart-agent-select mb-2">
            <label class="mr-2 small font-weight-bold">選擇經紀：</label>
            <select class="form-control form-control-sm d-inline-block" style="width:auto;"
              [(ngModel)]="chart_selected_agent" (change)="on_agent_select_change()">
              <option *ngFor="let ap of agent_platform_data" [value]="ap.agent">{{ ap.agent }}</option>
            </select>
          </div>
          <highcharts-chart *ngIf="platform_chart_visible"
            [Highcharts]="Highcharts"
            [options]="platformPieOptions"
            style="width:100%; display:block;">
          </highcharts-chart>
        </div>

      </div>

      <!-- 3. 經紀各社群表現折線圖（按指標 + 平台切換） -->
      <div class="chart-card mt-3">
        <div class="trend-toolbar">
          <div class="trend-metric-tabs">
            <button *ngFor="let m of trend_metrics"
              class="btn btn-sm"
              [ngClass]="trend_metric === m.key ? 'btn-primary' : 'btn-outline-secondary'"
              (click)="switch_trend_metric(m.key)">
              {{ m.label }}
            </button>
          </div>
          <div class="trend-platform-filter">
            <label class="small font-weight-bold mr-2 mb-0">平台：</label>
            <select class="form-control form-control-sm d-inline-block" style="width:auto;"
              [(ngModel)]="trend_platform" (change)="switch_trend_platform(trend_platform)">
              <option value="">全部平台</option>
              <option *ngFor="let p of trend_platform_options" [value]="p.id">{{ p.name }}</option>
            </select>
          </div>
        </div>
        <highcharts-chart *ngIf="trend_chart_visible"
          [Highcharts]="Highcharts"
          [options]="trendLineOptions"
          style="width:100%; display:block;">
        </highcharts-chart>
      </div>
    </div>

    <div *ngIf="!chart_ready && !loading" class="text-center text-muted py-5">
      <i class="fas fa-chart-pie fa-3x mb-3" style="opacity:.3"></i>
      <p>載入圖表中...</p>
    </div>

  </div>

  <!-- ══ Tab 3: 經紀指標 ═══════════════════════════════════════ -->
  <div *ngIf="now=='3'" class="tab-panel">

    <!-- 篩選區 -->
    <div class="filter-card">
      <div class="form-row align-items-end">
        <div class="form-group col-auto mb-1">
          <label>日期區間</label>
          <div>
            <app-date [time]="am_time" [timeset]="am_timeset" [css]="'width:240px;display:inline-block;'" (rangeSelected)="am_handleRangeSelected($event)"></app-date>
          </div>
        </div>
        <div class="form-group col-auto mb-1">
          <label>經紀</label>
          <select class="form-control form-control-sm" [(ngModel)]="am_filter_vendor" (change)="am_on_vendor_change()">
            <option value="">全部</option>
            <option *ngFor="let v of am_vendor_options" [value]="v">{{ v }}</option>
          </select>
        </div>
        <div class="form-group col-auto mb-1">
          <label>&nbsp;</label>
          <div>
            <button class="btn btn-outline-secondary btn-sm mr-1" (click)="am_reset_filter()">
              <i class="fas fa-redo mr-1"></i>重置
            </button>
            <button class="btn btn-sm" [ngClass]="am_show_help ? 'btn-info' : 'btn-outline-info'" (click)="am_show_help = !am_show_help">
              <i class="fas fa-question-circle mr-1"></i>指標說明
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 指標說明面板 -->
    <div class="am-help-panel" *ngIf="am_show_help">
      <div class="am-help-header">
        <i class="fas fa-book-open mr-2"></i>指標計算說明
        <button class="close ml-auto" (click)="am_show_help = false"><span>&times;</span></button>
      </div>
      <div class="am-help-body">
        <div class="am-help-section">
          <div class="am-help-title"><i class="fas fa-calendar-alt mr-1"></i>日期基準</div>
          <p>所有指標皆根據上方日期選擇器的<strong>區間</strong>計算，預設為過去 7 天。可透過快捷選項（今天、過去7天、本月等）快速切換。</p>
        </div>

        <div class="am-help-section">
          <div class="am-help-title"><i class="fas fa-hashtag mr-1"></i>數量總覽（左側面板）</div>
        </div>
        <div class="am-help-grid">
          <div class="am-help-item">
            <div class="am-help-badge" style="background:#667eea;">區間新增</div>
            <p>日期區間內<strong>開始合作</strong>（start_date 落在區間）且目前<strong>啟用中</strong>的成員總數。</p>
            <div class="am-help-formula">= 區間內 start_date 且 status=1 的成員數</div>
          </div>
          <div class="am-help-item">
            <div class="am-help-badge" style="background:#dc3545;">區間遺失</div>
            <p>日期區間內<strong>離開</strong>（end_date 落在區間）的成員總數。</p>
            <div class="am-help-formula">= 區間內 end_date 且 status=-1 的成員數</div>
          </div>
          <div class="am-help-item">
            <div class="am-help-badge" style="background:#17a2b8;">團隊總人數</div>
            <p>所有經紀底下目前<strong>啟用中</strong>（status=1）的成員加總，為活躍率的計算基數。</p>
            <div class="am-help-formula">= 全部經紀 vendor_member 中 status=1 的總數</div>
          </div>
          <div class="am-help-item">
            <div class="am-help-badge" style="background:#28a745;">區間上線數</div>
            <p>日期區間內，所有經紀中<strong>有上線紀錄</strong>（user.update_dt 在區間內）的成員人數加總。</p>
            <div class="am-help-formula">= 區間內 update_dt 有更新 且 status=1 的成員數</div>
          </div>
          <div class="am-help-item">
            <div class="am-help-badge" style="background:#fd7e14;">總發文數</div>
            <p>所有經紀底下社群帳號在<strong>日期區間內</strong>的發文總數。</p>
            <div class="am-help-formula">= 區間內所有社群帳號的貼文數加總</div>
          </div>
        </div>

        <div class="am-help-section" style="margin-top:16px;">
          <div class="am-help-title"><i class="fas fa-percentage mr-1"></i>效率指標（右側面板）</div>
        </div>
        <div class="am-help-grid">
          <div class="am-help-item">
            <div class="am-help-badge" style="background:#28a745;">平均活躍率</div>
            <p>各經紀活躍率的平均值。單一經紀活躍率 = 區間上線數 &divide; 團隊總人數。</p>
            <div class="am-help-formula">活躍率 = 區間上線數 &divide; 團隊總人數 &times; 100%</div>
          </div>
          <div class="am-help-item">
            <div class="am-help-badge" style="background:#dc3545;">平均流失率</div>
            <p>各經紀流失率的平均值。單一經紀流失率 = 區間遺失人數 &divide; 歷史最高人數（由每日排程記錄）。</p>
            <div class="am-help-formula">流失率 = 區間遺失人數 &divide; 歷史最高人數 &times; 100%</div>
          </div>
          <div class="am-help-item">
            <div class="am-help-badge" style="background:#e67e22;">日均發文數</div>
            <p>所有經紀在區間內每天平均發文數量的合計。</p>
            <div class="am-help-formula">= 各經紀日均發文數加總</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 摘要卡片（左：數量 / 右：比率） -->
    <div class="am-kpi-split" *ngIf="am_summary.length > 0">

      <!-- 左側：總數 -->
      <div class="am-kpi-panel">
        <div class="am-kpi-panel-header">
          <i class="fas fa-hashtag mr-1"></i>數量總覽
        </div>
        <div class="am-kpi-panel-grid">
          <div class="am-kpi-card">
            <div class="am-kpi-icon" style="background:linear-gradient(135deg,#667eea,#764ba2);">
              <i class="fas fa-user-plus"></i>
            </div>
            <div class="am-kpi-body">
              <div class="am-kpi-value">{{ am_total_new_users | number }}</div>
              <div class="am-kpi-label">區間新增</div>
            </div>
          </div>
          <div class="am-kpi-card">
            <div class="am-kpi-icon" style="background:linear-gradient(135deg,#dc3545,#e83e8c);">
              <i class="fas fa-user-minus"></i>
            </div>
            <div class="am-kpi-body">
              <div class="am-kpi-value">{{ am_total_lost | number }}</div>
              <div class="am-kpi-label">區間遺失</div>
            </div>
          </div>
          <div class="am-kpi-card">
            <div class="am-kpi-icon" style="background:linear-gradient(135deg,#17a2b8,#138496);">
              <i class="fas fa-users"></i>
            </div>
            <div class="am-kpi-body">
              <div class="am-kpi-value">{{ am_total_members | number }}</div>
              <div class="am-kpi-label">團隊總人數</div>
            </div>
          </div>
          <div class="am-kpi-card">
            <div class="am-kpi-icon" style="background:linear-gradient(135deg,#28a745,#20c997);">
              <i class="fas fa-signal"></i>
            </div>
            <div class="am-kpi-body">
              <div class="am-kpi-value">{{ am_total_online | number }}</div>
              <div class="am-kpi-label">區間上線數</div>
            </div>
          </div>
          <div class="am-kpi-card">
            <div class="am-kpi-icon" style="background:linear-gradient(135deg,#fd7e14,#ffc107);">
              <i class="fas fa-pen-fancy"></i>
            </div>
            <div class="am-kpi-body">
              <div class="am-kpi-value">{{ am_total_posts | number }}</div>
              <div class="am-kpi-label">總發文數</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 右側：比率 -->
      <div class="am-kpi-panel">
        <div class="am-kpi-panel-header">
          <i class="fas fa-percentage mr-1"></i>效率指標
        </div>
        <div class="am-kpi-panel-grid">
          <div class="am-kpi-card">
            <div class="am-kpi-icon" style="background:linear-gradient(135deg,#28a745,#20c997);">
              <i class="fas fa-user-check"></i>
            </div>
            <div class="am-kpi-body">
              <div class="am-kpi-value">{{ am_avg_active_rate }}%</div>
              <div class="am-kpi-label">平均活躍率</div>
            </div>
          </div>
          <div class="am-kpi-card">
            <div class="am-kpi-icon" style="background:linear-gradient(135deg,#dc3545,#e83e8c);">
              <i class="fas fa-user-slash"></i>
            </div>
            <div class="am-kpi-body">
              <div class="am-kpi-value">{{ am_avg_churn }}%</div>
              <div class="am-kpi-label">平均流失率</div>
            </div>
          </div>
          <div class="am-kpi-card">
            <div class="am-kpi-icon" style="background:linear-gradient(135deg,#fd7e14,#e67e22);">
              <i class="fas fa-chart-line"></i>
            </div>
            <div class="am-kpi-body">
              <div class="am-kpi-value">{{ am_avg_daily_posts }}</div>
              <div class="am-kpi-label">日均發文數</div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- 各經紀明細表格 -->
    <div class="table-wrapper mb-3" *ngIf="am_summary.length > 0">
      <table class="table table-hover mb-0">
        <thead>
          <tr>
            <th>經紀</th>
            <th class="text-right am-th-tip sortable" title="日期區間內開始合作(start_date)的成員數，不論目前狀態" (click)="am_toggle_sort('new_users')">新增用戶 <i class="fas fa-info-circle"></i> <i class="fas" [ngClass]="am_get_sort_icon('new_users')" [style.color]="am_get_sort_color('new_users')"></i></th>
            <th class="text-right am-th-tip sortable" title="該經紀公司底下的所有成員數" (click)="am_toggle_sort('total_members')">團隊總人數 <i class="fas fa-info-circle"></i> <i class="fas" [ngClass]="am_get_sort_icon('total_members')" [style.color]="am_get_sort_color('total_members')"></i></th>
            <th class="text-right am-th-tip sortable" title="區間內有上線紀錄的成員人數" (click)="am_toggle_sort('online_members')">上線人數 <i class="fas fa-info-circle"></i> <i class="fas" [ngClass]="am_get_sort_icon('online_members')" [style.color]="am_get_sort_color('online_members')"></i></th>
            <th class="text-right am-th-tip sortable" title="區間團隊上線人數 ÷ 團隊總人數 × 100%" (click)="am_toggle_sort('active_rate')">活躍率 <i class="fas fa-info-circle"></i> <i class="fas" [ngClass]="am_get_sort_icon('active_rate')" [style.color]="am_get_sort_color('active_rate')"></i></th>
            <th class="text-right am-th-tip sortable" title="區間內離開的成員數" (click)="am_toggle_sort('lost_members')">遺失人數 <i class="fas fa-info-circle"></i> <i class="fas" [ngClass]="am_get_sort_icon('lost_members')" [style.color]="am_get_sort_color('lost_members')"></i></th>
            <th class="text-right am-th-tip sortable" title="區間團隊遺失人數 ÷ 最高人數 × 100%" (click)="am_toggle_sort('churn_rate')">流失率 <i class="fas fa-info-circle"></i> <i class="fas" [ngClass]="am_get_sort_icon('churn_rate')" [style.color]="am_get_sort_color('churn_rate')"></i></th>
            <th class="text-right am-th-tip sortable" title="區間內該經紀所有社群帳號的發文總數" (click)="am_toggle_sort('total_posts')">總發文數 <i class="fas fa-info-circle"></i> <i class="fas" [ngClass]="am_get_sort_icon('total_posts')" [style.color]="am_get_sort_color('total_posts')"></i></th>
            <th class="text-right am-th-tip sortable" title="總發文數 ÷ 區間天數" (click)="am_toggle_sort('daily_posts')">日均發文 <i class="fas fa-info-circle"></i> <i class="fas" [ngClass]="am_get_sort_icon('daily_posts')" [style.color]="am_get_sort_color('daily_posts')"></i></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of am_summary">
            <td>{{ row.vendor_name }}</td>
            <td class="text-right font-weight-bold">
              <a *ngIf="row.new_users > 0" href="javascript:void(0)" class="am-clickable-num" style="color:#667eea;" (click)="open_member_detail(row, 'new_users', row.new_users)">
                {{ row.new_users | number }}
              </a>
              <span *ngIf="!row.new_users || row.new_users <= 0">0</span>
            </td>
            <td class="text-right">{{ row.total_members | number }}</td>
            <td class="text-right font-weight-bold">
              <a *ngIf="row.online_members > 0" href="javascript:void(0)" class="am-clickable-num" style="color:#28a745;" (click)="open_member_detail(row, 'online_members', row.online_members)">
                {{ row.online_members | number }}
              </a>
              <span *ngIf="!row.online_members || row.online_members <= 0" style="color:#28a745;">0</span>
            </td>
            <td class="text-right">
              <span [style.color]="row.active_rate >= 80 ? '#28a745' : row.active_rate >= 50 ? '#fd7e14' : '#dc3545'">
                {{ row.active_rate }}%
              </span>
            </td>
            <td class="text-right font-weight-bold">
              <a *ngIf="row.lost_members > 0" href="javascript:void(0)" class="am-clickable-num" style="color:#dc3545;" (click)="open_member_detail(row, 'lost_members', row.lost_members)">
                {{ row.lost_members | number }}
              </a>
              <span *ngIf="!row.lost_members || row.lost_members <= 0" style="color:#dc3545;">0</span>
            </td>
            <td class="text-right">
              <span [style.color]="row.churn_rate <= 10 ? '#28a745' : row.churn_rate <= 30 ? '#fd7e14' : '#dc3545'">
                {{ row.churn_rate }}%
              </span>
            </td>
            <td class="text-right">{{ row.total_posts | number }}</td>
            <td class="text-right">{{ row.daily_posts }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 圖表 -->
    <div *ngIf="am_chart_ready">

      <!-- 圓餅圖: 新增用戶占比 -->
      <div class="chart-grid">
        <div class="chart-card">
          <highcharts-chart
            [Highcharts]="Highcharts"
            [options]="am_pie_options"
            style="width:100%; display:block;">
          </highcharts-chart>
        </div>

        <!-- 活躍率 / 流失率 bar chart -->
        <div class="chart-card">
          <highcharts-chart
            [Highcharts]="Highcharts"
            [options]="am_bar_options"
            style="width:100%; display:block;">
          </highcharts-chart>
        </div>
      </div>

      <!-- 折線圖: 指標趨勢 -->
      <div class="chart-card mt-3">
        <div class="trend-toolbar">
          <div class="trend-metric-tabs">
            <button *ngFor="let m of am_trend_metrics"
              class="btn btn-sm"
              [ngClass]="am_trend_metric === m.key ? 'btn-primary' : 'btn-outline-secondary'"
              (click)="am_switch_metric(m.key)">
              {{ m.label }}
            </button>
          </div>
        </div>
        <highcharts-chart *ngIf="am_trend_visible"
          [Highcharts]="Highcharts"
          [options]="am_trend_options"
          style="width:100%; display:block;">
        </highcharts-chart>
      </div>

      <!-- 雷達圖: 收益分類 -->
      <div class="chart-card mt-3" *ngIf="am_filter_vendor">
        <div class="d-flex align-items-center mb-2" style="border-bottom:1px solid #e3e8ee; padding-bottom:12px;">
          <span style="font-weight:700; font-size:15px; color:#2d3748;">
            <i class="fas fa-chart-area mr-2" style="color:#667eea;"></i>各經紀收益分類雷達圖
          </span>
          <span *ngIf="am_filter_vendor" class="ml-2 badge badge-light" style="font-size:12px;">{{ am_filter_vendor }}</span>
        </div>
        <highcharts-chart
          [Highcharts]="Highcharts"
          [options]="am_radar_options"
          [update]="am_radar_update"
          style="width:100%; display:block;">
        </highcharts-chart>
      </div>

    </div>

    <div *ngIf="!am_chart_ready && !loading" class="text-center text-muted py-5">
      <i class="fas fa-tachometer-alt fa-3x mb-3" style="opacity:.3"></i>
      <p>載入經紀指標中...</p>
    </div>

  </div>

</div>

<!-- ══ Modal: 新增 / 編輯帳號 ════════════════════════════════════ -->
<div class="modal fade" id="accountModal" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-lg">
    <div class="modal-content" *ngIf="edit_data">
      <div class="modal-header" style="background:linear-gradient(135deg,#667eea,#764ba2);color:#fff;">
        <h5 class="modal-title"><i class="fas fa-edit mr-2"></i>{{ edit_data?.id ? '編輯' : '新增' }}社群帳號</h5>
        <button type="button" class="close text-white" (click)="close_account_modal()"><span>&times;</span></button>
      </div>
      <div class="modal-body">

        <!-- 社群資訊 -->
        <div class="card mb-3">
          <div class="card-header py-2" style="background:#f0f4ff;font-weight:600;">
            <i class="fas fa-hashtag mr-1"></i>社群資訊
          </div>
          <div class="card-body py-3">
            <div class="form-row">
              <div class="form-group col-md-4">
                <label>社群類型 <span class="text-danger">*</span></label>
                <select class="form-control" [(ngModel)]="edit_data.type" [disabled]="edit_data.id && edit_data.community_id">
                  <option *ngFor="let t of type_options" [value]="t.id">{{ t.name }}</option>
                </select>
              </div>
              <div class="form-group col-md-8">
                <label>URL <span class="text-danger">*</span></label>
                <input type="text" class="form-control" [(ngModel)]="edit_data.url" (ngModelChange)="detect_type_from_url()"
                  placeholder="https://www.instagram.com/帳號" [readonly]="edit_data.id && edit_data.community_id">
                <small *ngIf="edit_data.id && edit_data.community_id" class="text-muted">已登錄至外部系統，不可修改</small>
              </div>
            </div>
            <div class="form-group mb-0">
              <label>帳號名稱</label>
              <input type="text" class="form-control" [(ngModel)]="edit_data.account_name" placeholder="此社群的顯示名稱">
            </div>
          </div>
        </div>

        <!-- 經紀與狀態 -->
        <div class="card">
          <div class="card-header py-2" style="background:#fff8f0;font-weight:600;">
            <i class="fas fa-cog mr-1"></i>經紀與狀態
          </div>
          <div class="card-body py-3">
            <div class="form-row">
              <div class="form-group col-md-6 mb-0">
                <label>對應經紀</label>
                <select class="form-control" [(ngModel)]="edit_data.agent_name">
                  <option value="" disabled>請選擇經紀</option>
                  <option *ngFor="let v of vendor_list" [value]="v.name">{{ v.name }}</option>
                </select>
              </div>
              <div class="form-group col-md-6 mb-0">
                <label>狀態</label><br>
                <div class="btn-group btn-group-toggle">
                  <label class="btn btn-outline-success" [ngClass]="edit_data.is_enable=='1'?'active':''">
                    <input type="radio" [(ngModel)]="edit_data.is_enable" value="1"> 上架
                  </label>
                  <label class="btn btn-outline-secondary" [ngClass]="edit_data.is_enable=='0'?'active':''">
                    <input type="radio" [(ngModel)]="edit_data.is_enable" value="0"> 下架
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary px-4" (click)="save_account()" [disabled]="loading">
          <i class="fas fa-save mr-1"></i>{{ loading ? '儲存中...' : '儲存' }}
        </button>
        <button class="btn btn-outline-secondary" (click)="close_account_modal()">取消</button>
      </div>
    </div>
  </div>
</div>

<!-- ══ Modal: 文章詳情 ════════════════════════════════════════════ -->
<div class="modal fade" id="detailModal" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header" style="background:linear-gradient(135deg,#11998e,#38ef7d);color:#fff;">
        <h5 class="modal-title"><i class="fas fa-list-alt mr-2"></i>{{ detail_title }}</h5>
        <button type="button" class="close text-white" data-dismiss="modal" (click)="close_detail()"><span>&times;</span></button>
      </div>
      <div class="modal-body">
        <span class="hint-text ml-1"><i class="fas fa-info-circle mr-1"></i>每篇文章建立後只更新 14 天</span>
        <div class="table-wrapper mt-2">
          <table class="table table-hover table-sm mb-0">
            <thead>
              <tr>
                <th>貼文內容</th>
                <th class="text-center sortable" (click)="toggle_detail_sort('post_date')">
                  發文日期 <i class="fas" [ngClass]="get_detail_sort_icon('post_date')"></i>
                </th>
                <th class="text-center sortable" (click)="toggle_detail_sort('view_count')">
                  觀看次數 <i class="fas" [ngClass]="get_detail_sort_icon('view_count')"></i>
                </th>
                <th class="text-center sortable" (click)="toggle_detail_sort('like_count')">
                  點讚數 <i class="fas" [ngClass]="get_detail_sort_icon('like_count')"></i>
                </th>
                <th class="text-center sortable" (click)="toggle_detail_sort('comment_count')">
                  留言數 <i class="fas" [ngClass]="get_detail_sort_icon('comment_count')"></i>
                </th>
                <th class="text-center sortable" (click)="toggle_detail_sort('share_count')">
                  分享次數 <i class="fas" [ngClass]="get_detail_sort_icon('share_count')"></i>
                </th>
                <th class="text-center">最後更新時間</th>
                <th class="text-center">連結</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let post of detail_posts">
                <td style="max-width:300px;" class="text-truncate" [title]="post.title">{{ post.title }}</td>
                <td class="text-center">{{ post.post_date }}</td>
                <td class="text-center">{{ post.view_count | number }}</td>
                <td class="text-center">{{ post.like_count | number }}</td>
                <td class="text-center">{{ post.comment_count | number }}</td>
                <td class="text-center">{{ post.share_count | number }}</td>
                <td class="text-center text-muted small">{{ post.updated_at || '—' }}</td>
                <td class="text-center">
                  <a *ngIf="post.url" [href]="post.url" target="_blank" class="btn btn-sm btn-outline-primary">
                    <i class="fas fa-external-link-alt"></i>
                  </a>
                  <span *ngIf="!post.url" class="text-muted">—</span>
                </td>
              </tr>
              <tr *ngIf="detail_posts.length==0">
                <td colspan="8" class="text-center text-muted py-4">無資料</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="pager-bar mt-3" *ngIf="detail_total_pages > 1">
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" [class.disabled]="detail_page === 1">
              <a class="page-link" href="javascript:void(0)" (click)="detail_go_page(detail_page - 1)"><i class="fas fa-chevron-left"></i></a>
            </li>
            <li class="page-item" *ngFor="let p of detail_page_list" [class.active]="p === detail_page">
              <a class="page-link" href="javascript:void(0)" (click)="detail_go_page(p)">{{ p }}</a>
            </li>
            <li class="page-item" [class.disabled]="detail_page === detail_total_pages">
              <a class="page-link" href="javascript:void(0)" (click)="detail_go_page(detail_page + 1)"><i class="fas fa-chevron-right"></i></a>
            </li>
          </ul>
          <span class="pager-info">共 {{ detail_total }} 筆，第 {{ detail_page }} / {{ detail_total_pages }} 頁</span>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-outline-secondary" data-dismiss="modal" (click)="close_detail()">關閉</button>
      </div>
    </div>
  </div>
</div>

<!-- ══ Modal: 用戶明細（新增 / 上線 / 遺失 共用） ═════════════════ -->
<div class="am-modal-overlay" *ngIf="am_show_detail_modal" (click)="close_member_detail()"></div>
<div class="am-modal-panel" *ngIf="am_show_detail_modal">
  <div class="am-modal-header"
    [style.background]="am_detail_type === 'new_users' ? 'linear-gradient(135deg,#667eea,#764ba2)' :
                         am_detail_type === 'online_members' ? 'linear-gradient(135deg,#28a745,#20c997)' :
                         'linear-gradient(135deg,#dc3545,#e83e8c)'">
    <h5>
      <i class="fas mr-2" [ngClass]="am_detail_type === 'new_users' ? 'fa-user-plus' :
                                      am_detail_type === 'online_members' ? 'fa-user-check' : 'fa-user-minus'"></i>
      {{ am_detail_title }}
    </h5>
    <button class="close" (click)="close_member_detail()"><span>&times;</span></button>
  </div>
  <div class="am-modal-body">
    <div *ngIf="am_detail_loading" class="text-center py-5">
      <i class="fas fa-spinner fa-spin fa-2x"></i>
      <p class="mt-2 text-muted">載入中...</p>
    </div>
    <div *ngIf="!am_detail_loading && am_detail_list.length === 0" class="text-center text-muted py-5">
      <i class="fas fa-users fa-3x mb-3" style="opacity:.3"></i>
      <p>無資料</p>
    </div>
    <div *ngIf="!am_detail_loading && am_detail_list.length > 0" class="table-wrapper">
      <table class="table table-hover mb-0">
        <thead>
          <tr>
            <th>#</th>
            <th>名稱</th>
            <th>大頭貼</th>
            <th>電話號碼</th>
            <th class="text-center">性別</th>
            <th class="text-center">在線狀態</th>
            <th *ngIf="am_detail_type === 'new_users'" class="sortable" (click)="am_detail_toggle_sort('start_date')">合作開始日 <i class="fas" [ngClass]="am_detail_get_sort_icon('start_date')" [style.color]="am_detail_get_sort_color('start_date')"></i></th>
            <th *ngIf="am_detail_type === 'online_members'" class="sortable" (click)="am_detail_toggle_sort('last_active')">最後活躍時間 <i class="fas" [ngClass]="am_detail_get_sort_icon('last_active')" [style.color]="am_detail_get_sort_color('last_active')"></i></th>
            <th *ngIf="am_detail_type === 'lost_members'" class="sortable" (click)="am_detail_toggle_sort('end_date')">離開日期 <i class="fas" [ngClass]="am_detail_get_sort_icon('end_date')" [style.color]="am_detail_get_sort_color('end_date')"></i></th>
            <th class="text-right sortable" (click)="am_detail_toggle_sort('total_income')">區間總收益 (鑽) <i class="fas" [ngClass]="am_detail_get_sort_icon('total_income')" [style.color]="am_detail_get_sort_color('total_income')"></i></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let u of am_detail_paged; let i = index">
            <td>{{ (am_detail_page - 1) * am_detail_page_size + i + 1 }}</td>
            <td>
              <app-userandactive [post]="u"></app-userandactive>
            </td>
            <td>
              <img loading="lazy" [src]="u.profile_pic" class="am-user-avatar"
                   onerror="this.src='https://chatmate.tw/img/default.png'">
            </td>
            <td>{{ u.phone_num || '—' }}</td>
            <td class="text-center">{{ get_gender_label(u.gender) }}</td>
            <td class="text-center">
              <span [ngClass]="get_online_class(u.is_online)">
                <i class="fas fa-circle mr-1" style="font-size:8px;"></i>{{ get_online_label(u.is_online) }}
              </span>
            </td>
            <td *ngIf="am_detail_type === 'new_users'">{{ u.start_date }}</td>
            <td *ngIf="am_detail_type === 'online_members'">{{ u.last_active || u.start_date }}</td>
            <td *ngIf="am_detail_type === 'lost_members'">{{ u.end_date }}</td>
            <td class="text-right font-weight-bold" style="color:#667eea;">{{ u.total_income | number }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="am-modal-footer">
    <span class="text-muted small">共 {{ am_detail_list.length }} 位用戶</span>
    <nav *ngIf="am_detail_total_pages > 1">
      <ul class="pagination pagination-sm mb-0">
        <li class="page-item" [class.disabled]="am_detail_page <= 1">
          <a class="page-link" href="javascript:void(0)" (click)="am_detail_page = 1">«</a>
        </li>
        <li class="page-item" [class.disabled]="am_detail_page <= 1">
          <a class="page-link" href="javascript:void(0)" (click)="am_detail_page = am_detail_page - 1">‹</a>
        </li>
        <li class="page-item" *ngFor="let p of am_detail_pages" [class.active]="p === am_detail_page">
          <a class="page-link" href="javascript:void(0)" (click)="am_detail_page = p">{{ p }}</a>
        </li>
        <li class="page-item" [class.disabled]="am_detail_page >= am_detail_total_pages">
          <a class="page-link" href="javascript:void(0)" (click)="am_detail_page = am_detail_page + 1">›</a>
        </li>
        <li class="page-item" [class.disabled]="am_detail_page >= am_detail_total_pages">
          <a class="page-link" href="javascript:void(0)" (click)="am_detail_page = am_detail_total_pages">»</a>
        </li>
      </ul>
    </nav>
    <button class="btn btn-outline-secondary btn-sm" (click)="close_member_detail()">關閉</button>
  </div>
</div>

<app-spinner [loading]="loading"></app-spinner>
